import { render } from "./SectionCta.vue?vue&type=template&id=799b0dea&scoped=true"
import script from "./SectionCta.vue?vue&type=script&lang=js"
export * from "./SectionCta.vue?vue&type=script&lang=js"

import "./SectionCta.vue?vue&type=style&index=0&id=799b0dea&scoped=true&lang=css"

import exportComponent from "C:\\bluespeed\\bluespeed\\frontend\\bluespeed\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799b0dea"]])

export default __exports__